jQuery(function ($) {
    $('document').ready(function(){
        var urlSearch = new URLSearchParams(window.location.search);
        if(urlSearch.get('') == 'cadastro' || urlSearch.get('cadastro') != null){
          showCadastro();
        }
    })
});


